<template>
    <div class="containera">
      <div class="header">
        <div class="loadingContainer" v-if="!pdf">
          Belgeniz yükleniyor. Eğer açmak istediğiniz belgenin boyutu büyük ise, bu işlem biraz zaman alabilir. Lütfen bekleyiniz.
          <img src="../assets/loading_blue.gif" alt="">
        </div>
        <div v-if="pdf" class="page-number-container">
          Belgeniz {{ this.pdf.numPages }} sayfadır
        </div>
      </div>
      <div ref="pageContainer" class="page-container" v-show="pdf">
      </div>
    </div>
  </template>
  
  <script>
  import * as pdfjsLib from 'pdfjs-dist/build/pdf';
  
  export default {
    name: 'PDfViewer',
    props: {
      pdfUrl: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        url: this.pdfUrl,
        scale: 1.5,
        context: null,
        pdf: null,
        pageNumber: 1,
        pagesRendered: 0,
        pagesToRender: 2,
        scrolling: false
      }
    },
    mounted() {
      // pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.1.81/pdf.worker.js';
      pdfjsLib.GlobalWorkerOptions.workerSrc = window.location.origin + '/js/pdf.worker.js';
  
  
      const loadingTask = pdfjsLib.getDocument(this.url);
      loadingTask.promise.then(pdf => {
        console.log('PDF loaded');
        this.pdf = pdf;
        this.pageNumber = 1;
        this.renderPage();
        this.$refs.pageContainer.addEventListener('scroll', () => {
          if (this.scrolling) return;
          this.scrolling = true;
  
          setTimeout(() => {
            this.checkScroll();
            this.scrolling = false;
          }, 200);
        });
      }, reason => {
        console.error(reason);
      });
    },
    methods: {
      checkScroll() {
        const container = this.$refs.pageContainer;
        console.log(container.scrollHeight, Math.round(container.scrollTop), container.clientHeight)
        if ((container.scrollHeight - container.scrollTop === container.clientHeight) || ((container.scrollHeight - container.scrollTop)-5 <= (container.clientHeight))) {
          this.loadMorePages();
        }
      },
      loadMorePages() {
            if (this.pageNumber >= this.pdf.numPages) {
          // No more pages to load
          return;
        }
        this.pageNumber++;
        this.renderPage();
      },
      renderPage() {
        this.pdf.getPage(this.pageNumber).then(page => {
          console.log('Page loaded');
          const viewport = page.getViewport({ scale: this.scale });
  
          const canvas = document.createElement('canvas');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          this.$refs.pageContainer.appendChild(canvas);
          const context = canvas.getContext('2d');
  
          const renderContext = {
            canvasContext: context,
            viewport: viewport
          };
          const renderTask = page.render(renderContext);
          renderTask.promise.then(() => {
            console.log('Page rendered');
          });
        });
      }
    }
  };
  </script>
      // renderPage(pageNumber) {
      //   this.pdf.getPage(pageNumber).then(page => {
      //     console.log('Page loaded');
      //     const viewport = page.getViewport({ scale: this.scale });
      //     this.canvas.height = viewport.height;
      //     this.canvas.width = viewport.width;
      //     const renderContext = {
      //       canvasContext: this.context,
      //       viewport: viewport
      //     };
      //     const renderTask = page.render(renderContext);
      //     renderTask.promise.then(() => {
      //       console.log('Page rendered');
      //     });
      //   });
      // }
    <!-- }
  }
  </script> -->
  
  <style>
  
  .loadingContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    padding: 20px;
    margin-top: 20px;
    width: 100%;
    height: 50px;
    border-radius: 5px;
    background-color: white;
    font-weight: 700;
  }
  
  .loadingContainer img {
    margin-left: 10px;
  }
  
  .page-number-container {
    display: flex;
    width: inherit;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: inherit;
    border-radius: 5px;
    background-color: white;
    font-weight: 700;
  }
  
  .page-container {
    padding-top: 30px;
    height: 90vh;
    overflow-y: scroll;
    width: min-content;
  }
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px rgb(228, 228, 228); 
    border-radius: 10px;
  }
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background:rgb(73, 73, 73); 
    border-radius: 10px;
    cursor: pointer;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #c9c9c9; 
    cursor: pointer;
  }
  </style>